import { FETCH_SESSION_SUCCESS } from 'common/constants/actionTypes';

import PersonnelActions from 'common/redux/actions/personnel';

import Immutable from 'immutable';
import { Session } from 'common/models/internal/Session';
import { Personnel } from 'common/models/internal/Personnel';
import moment from 'moment-timezone';

export const session = (
    state = Immutable.fromJS({ session: null }),
    action
) => {
    switch (action.type) {
        case FETCH_SESSION_SUCCESS: {
            const session = Session.fromJS(action.response);
            const newState = state.set('session', session);

            // Setting locale of moment/moment-timezone globally
            const {
                personnel: { language: locale }
            } = session;

            // using native moment pseudo support here
            moment.locale(locale === 'en-PSEUDO' ? 'x-pseudo' : locale);
            // @TEMP_FIX: `dow` use is not consistent in the code
            // causing date shifts in some places. For now forcing
            // dow to be 0 to avoid issues
            // @TODO: add support of dow everywhere and remove this fix
            // - fix react-kronos (support partially dow)
            // - TimeUtils.getMomentWithEnglishLocale() uses dow=0 which can offset
            //   whole week if startOf('week') is used
            // - In some places we use moment.weekdaysMin() which always return starting from 'Sunday'
            //   that can cause issues
            moment.updateLocale(moment.locale(), {
                week: {
                    dow: 0
                }
            });

            return newState;
        }

        case PersonnelActions.UPDATE_PERSONNEL_SUCCESSS: {
            const { response: personnel } = action;
            return state
                .setIn(['session', 'personnel'], Personnel.fromJS(personnel))
                .set('isPhotoUploadInProgress', false);
        }
        case PersonnelActions.UPLOAD_PHOTO_START: {
            return state.set('isPhotoUploadInProgress', true);
        }
        case PersonnelActions.UPLOAD_PHOTO_FAILURE: {
            return state.set('isPhotoUploadInProgress', false);
        }
        default:
            return state;
    }
};
